/**
 * Layout: Intro - Vacature detail
 * Slug: vacature_detail_intro
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.vacature_detail_intro-layout');

	layouts.forEach((layout) => {
		
	});
});
